import React from "react";
import ReactDOM from "react-dom";
import YoutubeVideoPlayer from "../../components/assets/YoutubeVideoPlayer";

declare var root: any;

const YoutubeVideoWrapper = () => {
  return (
    <>
      <YoutubeVideoPlayer />
    </>
  );
};

if (root) {
  ReactDOM.render(<YoutubeVideoWrapper />, root);
}
